/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


function empty(element) {
	var children = Array.prototype.slice.call(element.childNodes);

	children.forEach(function (child) {
		element.removeChild(child);
	});

}

function wordIndex() {
	document.querySelectorAll('.section__title, .template-blog .page__title, [data-section-type="list-collections"] .page__title, .subscription .page__title').forEach((e) => {
		let words = e.textContent;
		let wordsSplit = words.split(/\s+/);
		let total = wordsSplit.length;

		empty(e);
		for (let index = 0; index < total; index++) {
			let div = document.createElement("span");
			div.classList.add(`word_${index}`);
			div.textContent = wordsSplit[index] + ' ';
			e.appendChild(div);
		}
	})

	if (document.querySelector('.view-more-btn') !== null) {
		document.querySelector('.view-more-btn').addEventListener('click', function to_position() {
			let seoCat = document.querySelector('.seo-collection');
			document.querySelector('html, body').scrollTo({
				top: seoCat.offsetTop - 150,
				behavior: 'smooth'
			});
		})
	}
}

var nosto = /*#__PURE__*/function () {
	nostojs(function (api) {
		api.listen('postrender', function (event) {
			document.querySelectorAll('.nosto_element .section__title').forEach((ev) => {
				let words = ev.textContent;
				let wordsSplit = words.split(/\s+/);
				let total = wordsSplit.length;

				empty(ev);
				for (let index = 0; index < total; index++) {
					let div = document.createElement("span");
					div.classList.add(`word_${index}`);
					div.textContent = wordsSplit[index] + ' ';
					ev.appendChild(div);
				}
			})
			dataLinkNosto();
		});
	});
	return nosto;
}();


function dataLink() {
	var dataLinksBtn = document.querySelectorAll('[data-link]');
	dataLinksBtn.forEach(function (variant) {
		variant.addEventListener('click', function (e) {
			e.stopPropagation();
			e.preventDefault();
			var link = e.target.dataset.link;
			if (link !== undefined) {
				window.location.href = e.target.dataset.link;
			}
		});
	})
}

function dataLinkBoost() {
	var dataLinksBtnNosto = document.querySelectorAll('.boost-pfs-filter-products [data-id-link]');
	dataLinksBtnNosto.forEach(function (variant) {
		variant.addEventListener('click', function (e) {
			e.stopPropagation();
			e.preventDefault();
			var id = e.target.dataset.idLink;
			var link = e.target.closest('.product-item__image-wrapper').dataset.url;
			let completeUrl = '';

			if (link.includes('?')) {
				completeUrl = link + '&variant=' + id
			} else {
				completeUrl = link + '?variant=' + id
			}
			window.location.href = completeUrl;
		});
	})
}

function dataLinkNosto() {
	var dataLinksBtnNosto = document.querySelectorAll('.nosto_element [data-id-link]');
	dataLinksBtnNosto.forEach(function (variant) {
		variant.addEventListener('click', function (e) {
			e.stopPropagation();
			e.preventDefault();
			var id = e.target.dataset.idLink;
			var link = e.target.closest('.product-item__image-wrapper').dataset.url
			let completeUrl = '';

			if (link.includes('?')) {
				completeUrl = link + '&variant=' + id
			} else {
				completeUrl = link + '?variant=' + id
			}
			window.location.href = completeUrl;
		});
	})
}

function scrollToTop(element, toElement) {
	window.scrollTo({
		top: element - toElement,
		behavior: 'smooth'
	});
}

const insertAdsInProduct = () => {
	let productList = document.querySelectorAll('#shopify-section-collection-template .container .layout__section .collection .collection__dynamic-part .product-list .product-item');
	let adsContainer = document.getElementById('adsinproduct');
	if (adsContainer !== undefined && adsContainer !== null && productList.length > 0) {
		let ads = adsContainer.querySelectorAll('.product-item ');
		ads.forEach(ad => {
			let position = ad.dataset.position;
			productList[position].insertAdjacentHTML('beforebegin', ad.outerHTML)
		})
		adsContainer.remove();
	}
}


document.addEventListener("DOMContentLoaded", function (event) {

	dataLink();
	wordIndex();

	setTimeout(function () {
		if (document.getElementById('AAI_email') !== null && document.getElementById('AAI_email').length > 0) {
			document.getElementById('AAI_email').setAttribute('placeholder', 'Email');
		}
	}, 3000);

	var readMoreBtn = document.querySelector('.read-m');
	var readLessBtn = document.querySelector('.read-l');
	var textContent = document.querySelector('[data-section-type="rich-text"] .rte')

	if (readMoreBtn != null) {
		readMoreBtn.addEventListener('click', function () {
			textContent.style.maxHeight = "100%"
			readMoreBtn.style.display = "none";
			readLessBtn.style.display = "block";
		});
	}

	if (readLessBtn != null) {
		readLessBtn.addEventListener('click', function () {
			textContent.style.maxHeight = "450px"
			readLessBtn.style.display = "none";
			readMoreBtn.style.display = "block";
		});
	}

	if (document.querySelector("#yopto-under-title") != 'undefined' && document.querySelector("#yopto-under-title") != null) {
		document.querySelector("#yopto-under-title").addEventListener('click', function (e) {
			e.preventDefault();
			document.querySelector('#product-reviews .card__collapsible-button').click();
		})
	}

	var brandAlphabet = document.querySelector(".brand-alphabet");
	if (brandAlphabet !== 'undefined' && brandAlphabet != null) {
		brandAlphabet.querySelectorAll('li').forEach((li) => {
			li.addEventListener("click", function (e) {
				let liVal = e.target.innerText.toLowerCase();
				let target = document.querySelector("#letter-" + liVal)
				let headerHeight = document.querySelector('[data-section-type="header"]').offsetHeight + 20;
				document.querySelector('body, html').scrollTo({
					top: target.getBoundingClientRect().top - headerHeight,
					behavior: 'smooth'
				});
				target.parentNode.classList.add('targeted');
				setTimeout(function () {
					target.parentNode.classList.remove('targeted');
				}, 1500);
			})
		})
	}

	if (window.theme.pageType === "customers/login") {
		document.querySelector('[data-action="toggle-login-form"]').addEventListener('click', () => {
			window.scroll({top: 0, left: 0, behavior: 'smooth'});
		})
	}
});


